<template>
	<div class="cd-unavailable">
		<div class="cd-unavailable-title red">
			<BaseCmsLabel v-if="itemStatus == 7 && labels.get('not_available_special')" code="not_available_special" tag="span" />
			<BaseCmsLabel v-else-if="itemStatus == 5 && labels.get('not_available_preorder')" code="not_available_preorder" tag="span" />
			<BaseCmsLabel v-else-if="labels.get('not_available')" code="not_available" tag="span" />
		</div>
		<div class="cd-unavailable-note">
			<BaseCmsLabel v-if="itemStatus == 7 && labels.get('not_available_note_special')" code="not_available_note_special" tag="span" />
			<BaseCmsLabel v-else-if="itemStatus == 5 && labels.get('not_available_note_preorder')" code="not_available_note_preorder" tag="span" />
			<BaseCmsLabel v-else-if="labels.get('not_available_note')" code="not_available_note" tag="span" />
		</div>
		<div class="cd-notifyme-form">
			<div class="form-notifyme cd-form-notifyme form-animated-label">
				<BaseFeedbackNotificationForm v-slot="{fields, status, loading}">
					<template v-if="!status?.success">
						<BaseFormField v-for="item in fields" :key="item.name" :item="item" v-slot="{errorMessage, floatingLabel}">
							<p class="field" :class="['field-' + item.name, {'ffl-floated': floatingLabel, 'hidden': item.type == 'hidden'}]">
								<BaseFormInput />
								<BaseCmsLabel tag="label" :for="item.name" code="enter_email" />
								<span class="error" v-show="errorMessage" v-html="errorMessage" />
							</p>
						</BaseFormField>
						<button class="btn btn-green btn-notifyme-form" type="submit" @click="onSubmit" :disabled="loading">{{ labels.get('notifyme') }}</button>
					</template>
					<div class="notifyme-success" v-show="status?.success">
						<div v-html="labels.get('notifyme_catalog_ty')" />
					</div>
				</BaseFeedbackNotificationForm>
			</div>
		</div>
	</div>
</template>

<script setup>
	const labels = useLabels();
	const props = defineProps(['itemStatus']);
</script>

<style lang="less" scoped>
	.cd-unavailable{
		flex-grow: 1; margin-bottom: 20px;

		@media (max-width: @ms){margin-bottom: 0;}
	}
	.cd-unavailable-title{
		font-size: 20px; line-height: 1.4; font-weight: 600;

		@media (max-width: @m){font-size: 18px;}
	}
	.cd-unavailable-note{
		font-size: 15px; line-height: 1.5; padding: 4px 0 15px;

		@media (max-width: @m){font-size: 13px; padding-bottom: 10px;}
	}
	.cd-notifyme-form{
		display: flex; align-items: flex-start; position: relative;

		@media (max-width: @m){display: block; min-height: 54px; position: relative;}
	}
	.cd-form-notifyme{
		display: flex; align-items: flex-start; flex-grow: 1; position: relative;
		:deep(form), .field{flex-grow: 1; padding: 0;}
		input{width: 100%; padding-right: 200px;}
		.error{position: absolute; top: 100%;}


		@media (max-width: @m){
			display: block;
			label{top: 16px;}
			.ffl-floated label{top: 7px;}
			:deep(input){padding-right: 100px;}
			.error{position: absolute; top: 47px;}
		}
	}
	.btn-notifyme-form{
		min-width: 150px; height: 54px; position: absolute; top: 0; right: 0; font-size: 15px;

		@media (max-width: @ms){width: calc(~"100% - 64px"); height: 54px; flex-grow: 1; margin-top: 15px; margin-left: 64px; padding: 0 15px; font-size: 15px; position: relative; top: unset; right: unset;}
	}
	.notifyme-success{
		color: @lightGreen;

		@media (max-width: @t){font-size: 15px; line-height: 1.4;}
		@media (max-width: @m){min-height: 110px; padding-right: 0;}
	}
</style>
